'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SetupFadeIn = function SetupFadeIn(elements) {
  var _this = this;

  (0, _classCallCheck3.default)(this, SetupFadeIn);

  if (window.Shopify.designMode) {
    document.body.classList.add('util-ShopifyDesignMode');
  }

  this.els = elements;

  this.offset = 200;

  var callback = function callback(entries, observer) {
    Array.from(entries).filter(function (entry) {
      return entry.isIntersecting;
    }).forEach(function (entry, index) {
      window.setTimeout(function () {
        entry.target.classList.add('js-FadeIn-visible');

        observer.unobserve(entry.target);
      }, (index + 1) * _this.offset);
    });
  };
  /* eslint-disable compat/compat */
  var observer = new IntersectionObserver(callback, {
    threshold: 0.4
  });
  /* eslint-enable */
  this.els.forEach(function (el) {
    return observer.observe(el);
  });
};

exports.default = SetupFadeIn;